import React from "react";

// Custom css import
import ms from "./CompletedProjects.module.css";
import ComingSoon from "../coming_soon/ComingSoon";

const CompletedProjects = () => {
  return (
    <>
      <div className={`${ms.page_main_container} container`}>
        <div className={`${ms.page_heading_container}`}>
          <h2 className={`text-center`}>Our Completed Projects</h2>
          <hr />
        </div>
      </div>
      <ComingSoon />
    </>
  );
};

export default CompletedProjects;
